"use client";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { TagSelectInput } from "./TagSelectInput";
import { useJobFilterStore } from "../../store/useJobFilterStore";
import { useCandidateProfileStore } from "../../store/useCandidateProfileStore";
import { useJobPreferenceStore } from "../../store/useJobPreferenceStore";

type PreferenceItem = { preferenceName: number };

type Props = {
  onClose: () => void;
  setPreference: (data: PreferenceItem[]) => void;
  defaultData: PreferenceItem[];
};

export default function EditPreferenceForm({ onClose, setPreference, defaultData }: Props) {
  const location = useLocation();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";
  const { jobPreferences = [], fetchFilters } = useJobFilterStore();

  // array of preference IDs (TagSelectInput expects array of IDs)
  const [selectedPreferenceIds, setSelectedPreferenceIds] = useState<number[]>([]);

  // fetch jobPreferences (preferences list)
  useEffect(() => {
    fetchFilters(lang, "jobPreferences");
  }, [lang, fetchFilters]);

  // mapping untuk TagSelectInput
  const preferenceOptions =
    (jobPreferences ?? []).map((item: any) => ({ id: item.id, name: item.name })) ?? [];

  // set initial selected ids after both jobPreferences + defaultData ready
  useEffect(() => {
    if (!Array.isArray(defaultData)) return;

    const initialIds = defaultData
      .map((item) => Number(item.preferenceName))
      .filter((id) => !Number.isNaN(id));

    setSelectedPreferenceIds(initialIds);
  }, [defaultData, jobPreferences]);

  const { fetchCandidateProfile } = useCandidateProfileStore();
  const { updateJobPreferences, loading } = useJobPreferenceStore();
  const handleSave = async () => {
    const result = selectedPreferenceIds.map((id) => ({
      preferenceName: id,
    }));

    const success = await updateJobPreferences(result);
    if (!success) return;
    fetchCandidateProfile();
    setPreference(result);
    onClose();
  };


  return (
    <div className="space-y-6 pb-4">
      <h3 className="text-lg font-semibold">{lang === "id" ? "Edit Preferensi" : "Edit Preferences"}</h3>

      <TagSelectInput
        label="Preferences"
        value={selectedPreferenceIds}
        onChange={setSelectedPreferenceIds} // return number[] from TagSelectInput
        options={preferenceOptions} // { id, name }
      />

      <div className="flex justify-center gap-4 pt-4">
        <button
          onClick={onClose}
          className="px-6 py-3 rounded-lg border text-gray-500 font-semibold"
        >
          {lang === "id" ? "Batal" : "Cancel"}
        </button>

        <button
          onClick={handleSave}
          className="px-6 py-3 rounded-lg bg-primary text-white font-semibold"
        >
          {lang === "id" ? "Simpan" : "Save"}
        </button>
      </div>
    </div>
  );
}
